import { CssBaseline } from '@mui/material';
import { useRoutes } from 'react-router-dom';
import { MatxTheme } from './components';
import { AuthProvider } from './contexts/JWTAuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import routes from './routes';
import { Provider } from 'react-redux';
import store from './redux/store';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    font-family:Poppins
  }
`;

const App = () => {
  const content = useRoutes(routes);

  return (
    <Provider store={store}>
      <SettingsProvider>
        <AuthProvider>
          <MatxTheme>
            <CssBaseline />
            <GlobalStyle />
            {content}
            
          </MatxTheme>
        </AuthProvider>
      </SettingsProvider>
    </Provider>
  );
};

export default App;
